import { registerComponent } from '../app'
import { OPEN_QUICK_BUY, CLOSE_QUICK_BUY, OPEN_CART } from '../events'
import Browser from '../services/Browser'

const QuickBuyOverlay = (scope, el) => {
	const props = {
		openClass: 'open'
	}

	const els = {
		content: el.querySelector('[data-content]')
	}

	scope.on(OPEN_QUICK_BUY, contentEl => {
		if (!Browser.isTablet()) return
		els.content.appendChild(contentEl)
		window.requestAnimationFrame(() => el.classList.add(props.openClass))
	})

	function close() {
		window.requestAnimationFrame(() => el.classList.remove(props.openClass))
	}

	scope.on(CLOSE_QUICK_BUY, () => close())

	scope.on(OPEN_CART, () => {
		close()
	})
}

registerComponent('quick-buy-overlay', QuickBuyOverlay)
